export function validateSize(size) {
    const sizeMap = {
        xs: 12,
        sm: 16,
        md: 24,
    };
    if (typeof size === 'string') {
        if (!sizeMap[size]) {
            console.warn(`Invalid size: ${size}. Defaulting to 'md'. Valid sizes are: ${Object.keys(sizeMap).join(', ')}, or a number.`);
        }
        else {
            return sizeMap[size];
        }
    }
    if (typeof size === 'number') {
        if (size <= 0) {
            console.warn('Invalid size: must be greater than 0. Defaulting to md.');
        }
        else {
            return size;
        }
    }
    return sizeMap['md'];
}
